// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"RandomizeFormSeparate__wrapper__1eqL-","results":"RandomizeFormSeparate__results__3k1pv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RandomizeFormSeparate/RandomizeFormSeparate.css
// module id = 3049
// module chunks = 0